import React, { Component } from 'react';
import SupportBase from "../common/SupportBase";
import { t } from '../../i18n';

export class NonconformityProcedure extends Component {

    render() {
        return <SupportBase
            currentUser={this.props.currentUser}
            contentName={'nonconformityProcedure'}
            title={ t('support.procedure.P14.title') }
            exportTitle={ t('support.procedure.P14.exportTitle') }
            exportFileName={'nonconformity_procedure.docx'}
            latestRevision={this.props.revision}
        />
    };
}

export default (NonconformityProcedure);
